import styled from 'styled-components';
import { Theme } from '@veneer/theme';
import { Modal } from '@veneer/core';

export const Title = styled.h2<{ $veneerTheme: Theme }>`
  font-size: ${({ $veneerTheme }) =>
    $veneerTheme.typography.titleRegular.fontSize};
  line-height: ${({ $veneerTheme }) =>
    $veneerTheme.typography.titleRegular.lineHeight};
  margin-bottom: ${({ $veneerTheme }) => $veneerTheme.layout.size4};
  color: ${({ $veneerTheme }) => $veneerTheme.color.black};
  @media (max-width: 575px) {
    font-size: ${({ $veneerTheme }) => $veneerTheme.typography.size4};
    line-height: ${({ $veneerTheme }) => $veneerTheme.typography.size6};
  }
`;

export const LoadCategory = styled.div<{ $veneerTheme: Theme }>`
  text-align: center;
`;

export const StyledModal = styled(Modal)<{ $veneerTheme: Theme; $id: string }>`
  ${({ $id, $veneerTheme }) => `
    #${$id}-label {
      padding-bottom: ${$veneerTheme.layout.size1};
    }
  `}
`;

export const TextGroup = styled.div<{ $veneerTheme: Theme }>`
  margin-top: ${({ $veneerTheme }) => $veneerTheme.layout.size6};
  display: flex;
  flex-direction: column;
  gap: ${({ $veneerTheme }) => $veneerTheme.layout.size4};
`;

export const TelemetryError = styled.div<{ $veneerTheme: Theme }>`
  margin-bottom: calc(
    ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
      ${({ $veneerTheme }) => $veneerTheme.layout.size2}
  );
`;
